import { useState, useEffect } from "react";

const useMobileScreen = (breakpoint = 769) => {
  const [isMobile, setIsMobile] = useState(window.outerWidth  < breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.outerWidth < breakpoint);
    };

    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default useMobileScreen;
